import CollectorInvitation from "./CollectorInvitation";
export default CollectorInvitation;
